<div class="preloader">
  <div class="loader"></div>
</div>
<div class="iso">
  <img
    src="./assets/shared/authentication/images/ico.svg"
    alt="ico"
    width="60"
    height="auto"
    /><br />
  </div>
  <div class="text-loading">
    @if (checkBrowserLanguage(['pt'])) {
      <span class="text-b">Iniciando sessão...</span>
      <br />
      Por favor aguarde enquanto validamos suas permissões e te redirecionamos.
    }
    @if (checkBrowserLanguage(['es'])) {
      <span class="text-b">Iniciando sesión...</span>
      <br />
      Por favor aguarde mientras validamos permisos y lo redireccionamos.
    }
    @if (!checkBrowserLanguage(['pt', 'es'])) {
      <span class="text-b">Starting session...</span>
      <br />
      Please wait while we validate permissions and redirect you.
    }
  </div>
